module.exports = __webpack_public_path__ + "media/src/img/payment/mbank-b46fcdc90dab3eba6f33eeda3274a863.svg";